import { useNetworkState as useNetworkStateOriginal } from "@uidotdev/usehooks";

/**
 * Custom hook to track network connectivity status
 * Uses @uidotdev/usehooks' useNetworkState under the hood
 *
 * @returns {boolean} isOnline - Whether the device is currently online
 *
 * @example
 * const isOnline = useNetworkState();
 *
 * if (!isOnline) {
 *   return <NotFoundPage title="Check your network connection" />;
 * }
 */
export const useNetworkState = (): boolean => {
  const networkState = useNetworkStateOriginal();
  return networkState.online ?? true; // Default to true if undefined
};
